import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import {
  StudiesIcon,
  DocumentPublicationsIcon,
  ReasonForPointAwardingIcon,
  TypesOfScoreIcon,
} from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";

const Index = () => {

  const data = [
    {
      name: getLocalizedString("coursesMaster"),
      icon: <StudiesIcon />,
      path: paths.coursesMaster,
    },
    {
      name: getLocalizedString("training"),
      icon: <DocumentPublicationsIcon />,
      path: paths.trainingDefinition,
    },
    {
      name: getLocalizedString("lms"),
      icon: <ReasonForPointAwardingIcon />,
      path: paths.myTraining,
    },
    {
      name: getLocalizedString("skillsRanking"),
      icon: <TypesOfScoreIcon />,
      path: paths.collaboratorSkillsRanking,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("trainingAndDevelopment")}
      data={data}
    />
  );
}

export default Index;